import styled from 'styled-components';

import { DefaultButtonStyled } from '@/components/atom/buttons/DefaultButton';
import ArrowBack from '@/components/atom/icon/Arrow/ArrowBack';
import ArrowForward from '@/components/atom/icon/Arrow/ArrowForward';
import WithHyperLinkComponent from '@/components/common/WithHyperLinkComponent';
import { ROUTES } from '@/types/common';
import { QnaDetailVo } from '@/types/qna';

interface Props {
  nearQuestions: QnaDetailVo['nearSimpleQuestions'];
  onClickNearQna: (direction: string, questionPid?: string) => void;
}
const NearQuestions = ({ nearQuestions, onClickNearQna }: Props) => {
  if (nearQuestions.next === null && nearQuestions.prev === null) {
    return <></>;
  }
  return (
    <Wrapper emptyPrev={!nearQuestions.prev}>
      {nearQuestions.prev && (
        <WithHyperLinkComponent
          href={`${ROUTES.QNA.DETAIL.path}/${nearQuestions.prev}`}
          onClick={(e) => {
            e.preventDefault();
            onClickNearQna('prev', nearQuestions.prev);
          }}
        >
          <Button>
            <ArrowBack />
            이전 질문
          </Button>
        </WithHyperLinkComponent>
      )}
      {nearQuestions.next && (
        <WithHyperLinkComponent
          href={`${ROUTES.QNA.DETAIL.path}/${nearQuestions.prev}`}
          onClick={(e) => {
            e.preventDefault();
            onClickNearQna('next', nearQuestions.next);
          }}
        >
          <Button next>
            다음 질문
            <ArrowForward />
          </Button>
        </WithHyperLinkComponent>
      )}
    </Wrapper>
  );
};

export default NearQuestions;

const Wrapper = styled.div<{ emptyPrev?: boolean }>`
  display: flex;
  padding: 24px;
  ${({ emptyPrev }) => `
    justify-content: ${emptyPrev ? 'flex-end' : 'space-between'};
  `}
`;

const Button = styled(DefaultButtonStyled)<{ next?: boolean }>`
  padding: 10px 16px;
  border-radius: 8px;
  ${({ theme, next }) => `
    ${theme.typography.UI14SB};
    color: ${theme.color.gray600};
    background: ${theme.color.gray50};
    svg {
      ${
        next
          ? `
        margin-left: 8px;
      `
          : `
        margin-right: 8px;
      `
      }
    }
    &:hover {
      background: ${theme.color.gray100};
    }
    &:active {
      background: ${theme.color.gray200};
    }
  `}
`;
